// Re-export shared domain types for convenience within the component
export type { SensorSelection, SensorAlertConfig } from "types/ISensorAlertConfig";

export enum SensorAlertState {
    EMPTY = "empty",
    INITIAL = "initial",
    CONFIGURATION = "configuration",
}

export interface SensorAlertSectionProps {
    locationPoint?: { lat: number; lng: number };
    geofence?: { lat: number; lng: number }[];
    macroRegionId?: number;
    macroRegionOrigin?: string;
}
